import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { Shell } from "./Shell";
import { FadeUp } from "./Sections";

const STORIES = [
  {
    title: "Strengthening the Alamo Area's Climate Plan",
    img: "https://harcresearch.org/wp-content/uploads/2026/03/shutterstock_2618287935.jpg",
    internal: true,
  },
  {
    title: "Community Resilience Through Urban Forestry",
    href: "https://harcresearch.org/research/community-resilience-through-urban-forestry/",
    img: "https://images.unsplash.com/photo-1582719299076-dd3f6f970dd4",
  },
  {
    title: "DOE Southcentral Onsite Energy Technical Assistance",
    href: "https://harcresearch.org/research/doe-southcentral-onsite-energy-technical-assistance/",
    img: "https://images.unsplash.com/photo-1675130277336-23cb686f01c0",
  },
];

const CardInner = ({ title }) => (
  <div className="absolute inset-x-0 bottom-0 p-7">
    <p className="mb-2 text-[11px] font-bold uppercase tracking-[0.18em] text-[#C9DA2D]">
      Impact Story
    </p>
    <h3 className="harc-heading text-xl font-normal leading-snug text-white md:text-2xl">
      {title}
    </h3>
    <p className="mt-3 text-xs italic text-white/70">
      [HARC CONTENT REQUIRED: 1–2 sentence teaser]
    </p>
    <span className="mockup-link-arrow mt-4 !text-white">
      Read the Story <ArrowRight size={14} aria-hidden="true" />
    </span>
  </div>
);

export default function ImpactIndex() {
  return (
    <Shell>
      <div data-testid="impact-index-page">
        <section className="mx-auto max-w-7xl px-6 pt-16 md:pt-24">
          <FadeUp>
            <p className="mb-5 text-xs font-bold uppercase tracking-[0.18em] text-[#004778]">
              Impact
            </p>
            <h1 className="harc-heading max-w-3xl text-4xl font-medium leading-[1.1] tracking-tight text-[#004778] md:text-6xl">
              Science in Action. Impact You Can See.
            </h1>
            <p className="mt-6 max-w-2xl text-base leading-relaxed text-[#5C6B72] md:text-lg md:font-light">
              Behind every HARC project is an opportunity to create meaningful change. Explore the
              stories of how HARC combines science, collaboration, and practical solutions to
              improve quality of life and build a resilient future.
            </p>
            <a href="#stories-grid" className="mockup-link-arrow mt-8" data-testid="impact-explore-cta">
              Explore Our Impact <ArrowRight size={15} aria-hidden="true" />
            </a>
          </FadeUp>
        </section>

        <section id="stories-grid" className="mx-auto max-w-7xl px-6 py-20">
          <div className="grid gap-5 md:grid-cols-3">
            {STORIES.map((s, i) => (
              <FadeUp key={s.title} delay={i * 0.08}>
                {s.internal ? (
                  <Link
                    to="/impact-story"
                    className="story-card group h-[340px]"
                    data-testid={`impact-card-${i + 1}`}
                  >
                    <img src={s.img} alt="" loading="lazy" />
                    <div className="scrim" aria-hidden="true" />
                    <CardInner title={s.title} />
                  </Link>
                ) : (
                  <a
                    href={s.href}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="story-card group h-[340px]"
                    data-testid={`impact-card-${i + 1}`}
                  >
                    <img src={s.img} alt="" loading="lazy" />
                    <div className="scrim" aria-hidden="true" />
                    <CardInner title={s.title} />
                  </a>
                )}
              </FadeUp>
            ))}
            {[1, 2, 3].map((n) => (
              <FadeUp key={n} delay={0.24 + n * 0.08}>
                <div
                  className="flex h-[340px] flex-col items-center justify-center border border-dashed border-[#004778]/40 p-8 text-center"
                  data-testid={`impact-placeholder-${n}`}
                >
                  <p className="harc-heading text-lg text-[#004778]">Impact Story</p>
                  <p className="mt-3 text-xs italic leading-relaxed text-[#5C6B72]">
                    [HARC CONTENT REQUIRED: verified Impact Story with image, problem-led headline,
                    and teaser]
                  </p>
                </div>
              </FadeUp>
            ))}
          </div>
          <p className="mt-8 text-xs italic text-[#5C6B72]">
            Three real HARC projects shown as demonstration stories; placeholder tiles show how the
            system grows as verified Impact Stories are published.
          </p>
        </section>
      </div>
    </Shell>
  );
}
